import { render, staticRenderFns } from "./task-strategy.vue?vue&type=template&id=72c4e284&scoped=true&"
import script from "./task-strategy.vue?vue&type=script&lang=js&"
export * from "./task-strategy.vue?vue&type=script&lang=js&"
import style0 from "./task-strategy.vue?vue&type=style&index=0&id=72c4e284&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c4e284",
  null
  
)

export default component.exports